export default {
    fund: [{
            "title": "某公司债券在支付期期初的浮动利率为5%，固定利差为30个基点，则该浮动利率债券支付期期初的基准利率为（　　）。",
            "question": "A. 2.00%\nB. 5.30%\nC. 4.70%\nD. 4.97%",
            "answer": "C",
            "explain": "本题考查浮动利率债券。浮动利率=基准利率+利差，国际惯例将利差用基点表示，1个基点（1bps）等于0.01%。本题中，浮动利率为5%，固定利差为30个基点，则基准利率=浮动利率-利差=5%-30×0.01%=4.70%。"
        },
        {
            "title": "某债券市场价格为97.33元，到期收益率为6%，修正久期为2.7年，若该债券的到期收益率增加0.2%，债券市场价格变动百分比是（　　）。",
            "question": "A. -0.54%\nB. 0.19%\nC. 0.54%\nD. -0.19%",
            "answer": "A",
            "explain": "债券价格变动的百分比公式为：dP/P = -D_mod dy，其中，D_mod表示修正久期。本题中，D_mod=2.7，dy=0.2%，代入公式得：dP/P = -2.7 × 0.2% = -0.54%。"
        },
        {
            "title": "关于可回售债券的表述，错误的是（　　）。",
            "question": "A. 与一个其他属性相同但没有回售条款的债券相比，可回售债券的利息通常更高\nB. 可回售债券的回售价格通常是债券的面值\nC. 可回售债券的受益人是持有者\nD. 可回售债券赋予持有者看跌期权的价值",
            "answer": "A",
            "explain": "本题考查可回售债券。B、D选项表述正确，可回售债券为债券持有者提供在债券到期前的特定时段以事先约定价格将债券回售给发行人的权利，即赋予持有者看跌期权的价值。约定的价格称为回售价格，回售价格通常是债券的面值。A选项表述错误，C选项表述正确，可回售债券的受益人是持有者，则和一个其他属性相同但是没有回售条款的债券相比，可回售债券的利息更低。"
        },
        {
            "title": "公司减少注册资本，回购自己股票的，必需短期内（　　）。",
            "question": "A. 卖出\nB. 注销\nC. 转让\nD. 拆分",
            "answer": "B",
            "explain": "本题考查股票回购。股票回购是指上市公司利用现金等方式从股票市场上购回本公司发行在外股票的行为，会减少流通在外的股份，购回的股票会被注销或以库存股形式存在。因此公司减少注册资本，回购自己股票的，必需短期内注销。"
        },
        {
            "title": "关于债券的当期收益率，以下表述正确的是（　　）。",
            "question": "A. 债券的年利息收入与当前的债券市场价格的比率\nB. 债券的年利息收入与债券的内在价值的比率\nC. 债券的年利息收入与债券面值的比率\nD. 债券的年利息收入与债券的到期收益的比率",
            "answer": "A",
            "explain": "本题考查当期收益率的概念。当期收益率又称当前收益率，是债券的年利息收入与当期的债券市场价格的比率。"
        },
        {
            "title": "投资者投资某项目，在未来第5年年末将得到50000元，期间没有任何货币收入。假设投资者希望得到的年利率为10%，则按复利计算该项投资的现值为（　　）。",
            "question": "A. 33205.47元\nB. 31046.07元\nC. 28223.70元\nD. 33333.33元",
            "answer": "B",
            "explain": "本题考查复利现值的计算。复利现值的计算公式为：PV=FV/(1+i)^n，式中：PV表示终值，即在第n年年末的货币终值；n表示年限；i表示年利率；PV表示本金或现值。本题中，FV=50000，i=10%，n=5，代入公式得：PV=50000/(1+10%)^5=31046.07元。"
        }, {
            "title": "当估值错误率达到或超过基金资产净值的（　　）时，基金管理人应当公告并报监管机构备案。",
            "question": "A. 0.5%\nB. 0.1%\nC. 1%\nD. 0.25%",
            "answer": "A",
            "explain": "本题考查计价错误的处理。基金管理公司应制定估值及份额净值计价错误的识别及应急方案。当错误达到或超过基金资产净值的0.25%时，基金管理人应及时向中国证监会报告。当估值错误率达到或超过基金资产净值的0.5%时，基金管理人应当公告并报监管机构备案。"
        },
        {
            "title": "关于投资债券的风险，以下表述正确的是（　　）。",
            "questions": "I. 只要债券发行人没有违约，投资人就不会因为信用风险遭受损失<br>II. 浮动利率债券的利息是浮动的，因此不会面临通货膨胀风险<br>III. 固定利率债券的价格与利率呈反向变动关系<br>IV. 买卖价差越小，债券的流动性越高",
            "question": "A. II、III、IV\nB. III、IV\nC. I、II、III\nD. I、IV",
            "answer": "B",
            "explain": "本题考查债券投资的风险。I项错误，即使债券发行人未真正地违约，债券持有人仍可能因为信用风险而遭受损失。市场可以根据宏观经济和发行人的状况来判断某一债券是否有违约可能。"
        },
        {
            "title": "假设有2只债券，债券A是零息债券，面值为1000元，还有3年到期；债券B是附息债券，面值为1000元，票面利率2%，还有3年到期。已知市场利率为10%，以下表述错误的是（　　）。",
            "question": "A. 债券A的现值为751.3\nB. 债券A并没有利息收入，计算现值时贴现率可以采用市场利率\nC. 如果债券B当前的价格为830元，那么债券B已有投资价值\nD. 债券B的现值大于债券A的现值",
            "answer": "C",
            "explain": "本题考查零息债券与固定利率债券。固定利率债券内在价值的计算公式为V=C/(1+r)^1 + C/(1+r)^2 + ... + C/(1+r)^n + M/(1+r)^n"
        },
        {
            "title": "基金公司投资交易流程不包括（　　）。",
            "question": "A. 风险控制\nB. 绩效评估与组合调整\nC. 形成投资策略\nD. 基金销售推介",
            "answer": "D",
            "explain": "本题考查投资交易流程。基金公司投资交易流程包括形成投资策略、构建投资组合、执行交易指令、绩效评估与组合调整、风险控制等环节。综上所述，D选项符合题意。"
        },
        {
            "title": "关于可转债的回售条款，下列说法正确的是（　　）。",
            "question": "A. 回售价格根据回售时标的股票市价确定\nB. 回售条款由发行人行使\nC. 回售条款由可转债持有人行使\nD. 股票下跌时，可转债持有人可以行使回售条款",
            "answer": "C",
            "explain": "本题考查可转换债券的回售条款。回售条款指可转债持有者有权在约定的条件触发时按照事先约定的价格将可转债卖回给发行企业的规定。一般在股票价格下跌超过一定幅度时生效。所以回售条款由可转债持有人行使。"
        },
        {
            "title": "关于基金份额分拆与合并，以下表述错误的是（　　）。",
            "question": "A. 基金份额的分拆可以降低投资者对价格的敏感性，有利于基金持续营销\nB. 基金份额分拆通过直接调整基金份额数量达到降低基金份额净值的目的，并不影响已实现收益、未实现利得等\nC. 当基金净值过高时，通过基金份额合并可以降低其净值\nD. 当基金的净值过低时，通过基金份额的合并可以提高其净值，这种行为被称为逆向分拆",
            "answer": "C",
            "explain": "本题考查基金份额的分拆与合并。A、B选项表述正确，基金份额分拆可以降低投资者对价格的敏感性，有利于基金持续营销、改善基金份额持有人结构、基金经理更为有效地运作资金。基金份额分拆通过直接调整基金份额数量达到降低基金份额净值的目的，但并不影响基金的已实现收益、未实现利得等。C选项表述错误，D选项表述正确，当基金净值过高时，应通过基金份额分拆以降低其净值，而通过份额合并只会增加其净值。当基金的净值过低时，通过基金份额的合并可以提高其净值，通常也称之为逆向分拆。"
        }, {
            "title": "甲公司2015年资产收益率为10%，负债权益比为1.5，则甲公司2015年的净资产收益率为（　　）。",
            "question": "A. 20%\nB. 15%\nC. 25%\nD. 30%",
            "answer": "C",
            "explain": "本题考查净资产收益率的计算。净资产收益率=净利润/所有者权益=(10%×总资产)+（总资产×40%)=25%。"
        },
        {
            "title": "以下不属于按保证形式划分的有保证债券的是（　　）。",
            "question": "A. 抵押债券\nB. 信用债券\nC. 担保债券\nD. 质押债券",
            "answer": "B",
            "explain": "本题考查按保证形式划分的有保证债券。债券有无保证是影响债券信用等级的重要因素，因此可分为有保证债券和无保证债券，后者也称为信用债券。"
        },
        {
            "title": "关于风险价值及预期损失的异同，以下表述错误的是（　　）。",
            "question": "A. 风险价值可以体现将来可能发生但没有在历史数据中体现的情景\nB. 风险价值是指在给定的时间区间和置信水平下，利率、汇率等市场风险要素发生变化时，投资组合面临的潜在最大损失\nC. 风险价值与预期损失都无法体现将来可能发生但没有在历史数据中体现的情景\nD. 预期损失是指在给定时间区间和置信水平投资组合损失的期望值",
            "answer": "A",
            "explain": "本题考查风险价值与预期损失。风险价值和预期损失都无法体现那些将来可能发生但没有在历史数据中体现的情景。"
        },
        {
            "title": "关于远期利率和即期利率，以下表述错误的是（　　）。",
            "question": "A. 现代金融分析中，远期利率有着非常广泛的应用\nB. 即期利率可以预示市场对未来利率走势的期望\nC. 远期利率是制定和执行货币政策的参考工具\nD. 成熟市场中几乎所有利率衍生品都依赖于远期利率",
            "answer": "B",
            "explain": "本题考查远期利率的应用。远期利率预示市场对未来利率走势的期望。"
        },
        {
            "title": "下列表述中，不属于现金流量表特点的是（　　）。",
            "question": "A. 评价企业偿还债务，支付投资利润的能力\nB. 分析净收益与现金流量间的差异，并解释差异产生的原因\nC. 反映公司资产负债平衡关系\nD. 反映企业的现金流量，评价企业未来产生现金净流量的能力",
            "answer": "C",
            "explain": "本题考查现金流量表的特点。反映公司资产负债平衡关系属于资产负债表的特点。"
        },
        {
            "title": "关于投资政策说明书，以下表述错误的是（　　）。",
            "question": "A. 制定投资政策说明的关键环节之一是对投资者需求进行分析\nB. 制定投资政策说明书的好处之一是有助于合理评估投资管理人的投资业绩\nC. 投资政策说明书能够帮助投资者制定切合实际的投资目标\nD. 投资政策说明书在制定之后不能一成不变，也不能想变就变，只能每年定期进行更新",
            "answer": "D",
            "explain": "本题考查制定投资政策说明书的内容。由于说明书中涉及的投资者需求会不断变化，因此投资政策说明书在制定后需要定期或不定期地进行重新审核和更新。"
        }, {
            "title": "因发生违约交收、技术故障等原因给证券登记结算机构造成损失，垫付或弥补该项损失的资金来源是（　　）。",
            "question": "A. 证券结算风险基金\nB. 保险机构\nC. 中国证监会\nD. 交易所",
            "answer": "A",
            "explain": "本题考查证券登记结算机构的管理措施。为防范证券结算风险，我国设立了证券结算风险基金用于垫付或弥补因违约交收、技术故障、操作失误、不可抗力等造成的证券登记结算机构的损失。"
        },
        {
            "title": "封闭式基金披露资产净值和份额净值的频率是（　　）。",
            "question": "A. 至少每个开放日一次\nB. 至少每周两次\nC. 至少每周一次\nD. 至少每月一次",
            "answer": "C",
            "explain": "本题考查封闭式基金的估值频率。封闭式基金每周披露一次基金份额净值，但每个交易日也都进行估值。"
        },
        {
            "title": "在银行间债券市场的做市商，需要承担的职责有（　　）。",
            "question": "A. 受中国人民银行委托，代中国人民银行与投资者进行交易\nB. 仅向投资者卖出债券\nC. 随机向投资者进行报价\nD. 以自有资金和债券与投资者进行交易",
            "answer": "D",
            "explain": "本题考查做市商制度。做市商制度是指在债券市场上，由具有一定实力和信誉的市场参与者作为特许交易商，不断向投资者报出某些特定债券的买卖价格，双向报价并在该价位上接受投资者的买卖要求，以其自有资金和债券与投资者进行交易的制度。"
        },
        {
            "title": "远期合约、期货合约、期权合约和互换合约的最主要的区别，可以通过（　　）角度来分析。",
            "questions": "I. 合约标准化程度<br>II. 交易场所<br>III. 杠杆<br>IV. 执行方式",
            "question": "A. I、II、IV\nB. I、III、IV\nC. II、III、IV\nD. I、II、III",
            "answer": "B",
            "explain": "本题考查远期合约、期货合约、期权合约和互换合约的区别。远期合约、期货合约、期权合约和互换合约是四种最常见的衍生工具，我们可以从合约的标准化程度（I项符合题意）、交易场所、损益特性、信用风险、交易方式、执行方式（IV项符合题意）等角度来分析这四种主要衍生工具的区别。"
        },
        {
            "title": "关于系统性风险和非系统性风险，以下表述错误的是（　　）。",
            "question": "A. 非系统性风险往往是有某个或者少数个别因素导致的\nB. 资本市场线上的任一组合都只有非系统性风险\nC. 系统性风险是指在一定程度上无法通过一定范围内的分散化投资来降低的风险\nD. 非系统性风险可以通过组合化投资进行分散",
            "answer": "B",
            "explain": "本题考查资本市场线和证券市场线的概念与区别。资本市场线中，我们用方差/标准差来衡量总风险（并非只是系统性风险，B项错误）。但是资本市场线线上的市场组合是一个完全分散化的资产组合，其非系统性风险都被分散掉了，只有系统性风险。"
        },
        {
            "title": "基金进行利润分配，会对基金份额净值和投资者利益产生的影响是（　　）。",
            "question": "A. 基金份额净值会下降，但投资者利益不受影响\nB. 基金份额净值会下降，投资者利益会相应减少\nC. 基金份额净值不变，投资者利益会相应减少\nD. 基金份额净值不变，但投资者利益会相应减少",
            "answer": "A",
            "explain": "本题考查基金利润分配。基金进行利润分配会导致基金份额净值的下降，但对投资者的利益没有实际影响。"
        }, {
            "title": "以下属于证券投资基金场内证券交易结算原则的有（　　）。",
            "questions": "I. 法人结算原则<br>II. 共同对手方制度<br>III. 货银对付原则<br>IV. 分级结算原则",
            "question": "A. I、II、III、IV\nB. I、III、IV\nC. I、II、III\nD. I、III、IV",
            "answer": "A",
            "explain": "本题考查场内证券交易结算的原则。场内证券交易结算原则包括：法人结算原则、共同对手方制度、货银对付原则、分级结算原则。"
        },
        {
            "title": "根据马可维茨的投资组合理论，在识别有效投资组合时，不需要考虑的是（　　）。",
            "question": "A. 每种证券与其他证券之间的相互关系\nB. 每种证券期望收益率的方差\nC. 投资者对每种证券的偏好\nD. 每种证券的期望收益率",
            "answer": "C",
            "explain": "本题考查有效投资组合识别需考虑的因素。根据马可维茨的投资组合理论，在识别有效投资组合时，通过对每种证券的期望收益率、收益率的方差和每一种证券与其他证券之间的相互关系(以协方差来度量)的适当分析，可在理论上识别出有效投资组合。"
        },
        {
            "title": "关于资产收益率，以下表述正确的（　　）。",
            "question": "A. 资产收益率通常不高于净资产收益率\nB. 资产收益率越高表明企业有较强的利用净资产创造利润的能力\nC. 资产收益率能反映企业中长期的偿债能力",
            "answer": "A",
            "explain": "本题考查资产收益率。资产通常不低于净资产，所以资产收益率通常不高于净资产收益率。资产收益率是应用最为广泛的衡量企业盈利能力的指标之一。资产收益率高，表明企业有较强的利用资产(并非净资产)创造利润的能力。资产收益率属于盈利能力指标，不能反映企业中长期的偿债能力。"
        },
        {
            "title": "对基金拥有的全部资产和负债按一定的原则和方法进行估算，确定基金资产公允价值的过程，称之为（　　）。",
            "question": "A. 基金会计核算\nB. 基金资产估值\nC. 基金利润分配\nD. 基金信息披露",
            "answer": "B",
            "explain": "本题考查基金资产估值。基金资产估值是指通过对基金所拥有的全部资产及全部负债按一定的原则和方法进行估算，进而确定基金资产公允价值的过程。"
        },
        {
            "title": "跨境投资风险不包含以下哪类风险（　　）。",
            "question": "A. 交易估值风险\nB. 税收风险\nC. 合规风险\nD. 再投资风险",
            "answer": "D",
            "explain": "本题考查跨境投资风险。跨境投资风险主要分为政治风险、汇率风险、税收风险、投资研究风险、交易和估值风险、合规风险六个部分。"
        },
        {
            "title": "关于含有嵌入条款的债券，下列哪种条款是对债券发行人有利的（　　）。",
            "question": "A. 转换条款\nB. 通货膨胀联结条款\nC. 赎回条款\nD. 回售条款",
            "answer": "C",
            "explain": "本题考查赎回条款。赎回条款是发行人的权利而非持有者，换句话说，是保护债务人而不是债权人的条款，对债权人不利，即赎回条款是对债券发行人有利的。"
        }, {
            "title": "甲公司发行了面值为1000元的5年期零息债券，现在的市场利率为5%，则该债券的现值为（　　）。",
            "question": "A. 770.00元\nB. 680.58元\nC. 783.53元\nD. 750.00元",
            "answer": "C",
            "explain": "本题考查零息债券现值的计算。零息债券现值计算公式:V=M/(1+r)^t，式中:V表示贴现债券的内在价值;M表示面值;r表示市场利率;t表示债券到期时间。本题中，M=1000，t=5，i=5%，代入公式得，V=1000/(1+5%)^5=783.53(元)。"
        },
        {
            "title": "2019年某交易日，证券投资基金A卖出某股票50000元，个人投资者B卖出某证券投资基金1000元，则基金A和投资者B需要缴纳的印花税分别是多少（　　）。",
            "question": "A. 50, 0\nB. 500, 300\nC. 0, 0\nD. 50, 10",
            "answer": "A",
            "explain": "本题考查所得税。对于基金自身活动产生的印花税，从2008年9月19日起，实行单向征收，即卖出股票时按照1%的税率征收，而对买入交易不再征收印花税。个人投资者买卖基金份额暂免征收印花税。"
        },
        {
            "title": "关于杜邦分析法，以下表述正确的是（　　）。",
            "question": "A. 净资产收益率=销售利润率×净资产周转率×权益乘数\nB. 净资产收益率=销售利润率×总资产周转率×权益乘数\nC. 净资产收益率=销售利润率×存货周转率×权益乘数\nD. 净资产收益率=销售利润率×应收账款周转率×权益乘数",
            "answer": "B",
            "explain": "本题考查杜邦恒等式。杜邦恒等式的表达式为：净资产收益率=销售利润率×总资产周转率×权益乘数。"
        },
        {
            "title": "某基金100个交易日的每日基金净值变化的基点值-(单位:点)从小到大排列为4（1)4(100)。其中，←(91)(100)的值依次为:6.94、7.80、8.43、8.56、9.55、9.88、10.22、13.23，求←(91)+(100)的上3.5%分位数（　　）。",
            "question": "A. 9.715\nB. 0.4631\nC. 8.025\nD. 3.5",
            "answer": "A",
            "explain": "本题考查分位数的计算。3.5%=1/2 (9.88+9.55) =9.715"
        },
        {
            "title": "以下不属于基金暂停估值情形的是（　　）。",
            "question": "A. 某只基金重仓的债权到期后不能兑付，严重影响该基金的流动性\nB. 港股通产品，因台风警报，联交所宣布闭市一天\nC. 某基金投资经理申请年休假，基金无人管理\nD. 因估值系统准备不充分，某基金无法正确算出产品应纳增税额",
            "answer": "C",
            "explain": "本题考查暂停估值的情形。当基金有以下情形时，可以暂停估值：(1)基金投资所涉及的证券交易所遇法定节假日或因其他原因暂停营业时（B选项属于）。(2)因不可抗力或其他情形致使基金管理人、基金托管人无法准确评估基金资产价值时（D选项属于）。(3)占基金相当比例的投资品种的估值出现重大转变，而基金管理人为保障投资人的利益已决定延迟估值。"
        },
        {
            "title": "关于基金费用，以下表述错误的是（　　）。",
            "question": "A. 目前我国的基金销售服务费是按前一日基金资产净值的一定比例逐日计提，按月支付\nB. 基金销售服务费是向基金管理人收取的，用于支付销售机构佣金的费用\nC. 基金托管费是基金托管人提供托管服务而向基金收取的费用\nD. 基金管理费是基金管理人管理基金资产而向基金收取的费用",
            "answer": "B",
            "explain": "本题考查基金费用。销售服务费指从基金资产中扣除的用于支付销售机构佣金以及基金管理人的基金营销广告费、促销活动费、持有人服务费等方面的费用。"
        }, {
            "title": "在单笔交易规模较大的债券市场中，比较适合的结算方式是（　　）。",
            "question": "A. 双边净额结算\nB. 逐笔结算\nC. 券款净额结算\nD. 多边净额结算",
            "answer": "B",
            "explain": "本题考查证券交易结算的方式。全额结算即逐笔结算，适用于高度自动化系统的单笔交易规模较大的市场。"
        },
        {
            "title": "交易指令在基金公司内部执行的流程为（　　）。",
            "questions": "I. 交易员接收执行指令<br>II. 相关人员审核指令<br>III. 基金经理下达指令",
            "question": "A. II、III、I\nB. III、II、I\nC. I、II、III\nD. I、III、II",
            "answer": "B",
            "explain": "本题考查交易指令执行的流程。交易指令在基金公司内部的执行情况如下：基金经理下达指令，相关人员审核指令，交易员接收执行指令。"
        },
        {
            "title": "某企业的资产收益率是20%，若资产负债率也为20%，则净资产收益率是（　　）。",
            "question": "A. 20%\nB. 15%\nC. 25%\nD. 30%",
            "answer": "C",
            "explain": "本题考查净资产收益率的计算。资产收益率是20%，若资产负债率也为20%则权益乘数=1+(1-20%)=1.25;净资产收益率=20%x1.25=25%。"
        },
        {
            "title": "根据中央国债登记结算公司有关债券账户管理规定，QFII、RQFII可以在银行间债券市场参与交易，但只能申请成为丙类结算成员，在债券结算时需委托甲类结算成员办理。此处体现的交易制度是（　　）。",
            "question": "A. 结算参与人制度\nB. 做市商制度\nC. 公开市场一级交易商制度\nD. 结算代理制度",
            "answer": "D",
            "explain": "本题考查银行间债券市场的交易制度--结算代理制度。结算代理制度指经由中国人民银行批准可以开展结算代理业务的金融机构法人，受市场其他参与者的委托，为其办理债券结算业务的制度。"
        },
        {
            "title": "当经济处于收缩或下滑期时，公司的盈利能力下降，现金流恶化将导致（　　）。",
            "questions": "I. 投资者对公司债要求的风险溢价上升<br>II. 公司债的到期收益率上升<br>III. 公司债的价格下降<br>IV. 公司债相对于同期像国债的信用利差扩大",
            "question": "A. I、III\nB. I、II、III\nC. I、II、III、IV\nD. II、III、IV",
            "answer": "C",
            "explain": "本题考查公司债。债券有固定的票面利率和期限，因此其市场价格相对股票而言比较稳定。股权投资的风险更大，要求更高的风险溢价，其收益应该高于债权投资的。"
        },
        {
            "title": "基金公司投资风险管理的步骤可以分为（　　）。",
            "question": "A. 识别风险、测量风险、处理风险和风险管理的评估和调整\nB. 识别风险、判断风险、处理风险和风险管理的评估和调整\nC. 识别风险、测量风险、风险评估和处理风险\nD. 识别风险、判断风险、风险评估和处理风险",
            "answer": "A",
            "explain": "本题考查投资风险管理的步骤。基金公司投资风险管理的步骤可分为识别风险、测量风险、处理风险以及风险管理的评估和调整。"
        }, {
            "title": "某个人投资者以1元的基金净值申购某基金10000份后又以1.1元的基金净值赎回该基金1000份，不考虑费用，则该投资者此项获利需缴纳的税收情况是（　　）。",
            "question": "A. 应缴个人所得税50元\nB. 暂不征收个人所得税\nC. 应缴个人所得税100元\nD. 应缴个人所得税200元",
            "answer": "B",
            "explain": "本题考查个人投资者投资基金的税收。个人投资者买卖基金份额获得的差价收入，在对个人买卖股票的差价收入未恢复征收个人所得税以前，暂不征收个人所得税。"
        },
        {
            "title": "一般来说，在其他条件均相同的情况下，风险越低的股票所对应的期望回报率也越（　　），在股票的期望收益率相同的情况下，投资者对风险越低的股票出价越（　　）。",
            "question": "A. 低，低\nB. 低，高\nC. 高，高\nD. 高，低",
            "answer": "B",
            "explain": "本题考查权益类证券投资的收益。风险较高的股票对应着一个较高的风险溢价，其期望收益率一般也较高。因此，在其他条件均相同的情况下，风险越低的股票所对应的期望回报率也越低，在股票的期望收益率相同的情况下，投资者对风险越低的股票出价越高。"
        },
        {
            "title": "关于我国证券交易所，以下表述错误的是（　　）。",
            "question": "A. 证券交易所为证券集中交易提供场所和设施\nB. 证券交易所的设立和解散，由中国证券监督管理委员会决定\nC. 证券交易所组织和监督证券交易\nD. 证券交易所是实行自律管理的法人",
            "answer": "B",
            "explain": "本题考查证券交易所的概念。证券交易所是为证券集中交易提供场所和设施，组织和监督证券交易，实行自律管理的法人。证券交易所的设立和解散，由国务院决定。"
        },
        {
            "title": "基金从事场内证券交易，涉及的交易成本包括（　　）。",
            "question": "A. 佣金，过户费，经手费，印花税\nB. 经手费，印花税，登记费，席位费\nC. 佣金，证管费，备案费，印花税\nD. 佣金，过户费，备案费，经手费",
            "answer": "A",
            "explain": "本题考查场内证券交易与结算涉及的费用。基金通过与券商签订交易单元租用合同获得投资交易的路径，基金需要向券商支付交易佣金，还需要支付过户费、经手费、证管费、印花税等交易成本。"
        },
        {
            "title": "投资政策说明书是投资决策的指导性文件。关于投资政策说明书，以下表述正确的是（　　）。",
            "questions": "I. 投资政策说明书基于投资者多样化的投资需求、财务状况、投资限制和偏好等为投资者制定，投资政策说明书没有标准格式<br>II. 投资管理人需定期或不定期地对投资政策说明书进行重新审核和更新<br>III. 构建投资组合是进行投资组合管理的基础<br>IV. 投资政策说明书能有效指导投资决策的实践，能够确保投资者达到其收益目的",
            "question": "A. I、II\nB. I、III\nC. I、IV\nD. II、III",
            "answer": "A",
            "explain": "本题考查投资政策说明书。投资政策说明书基于投资者多样化的投资需求、财务状况、投资限制和偏好等为投资者制定，投资政策说明书没有标准格式；投资管理人需定期或不定期地对投资政策说明书进行重新审核和更新。"
        },
        {
            "title": "做市商制度是指（　　）。",
            "question": "A. 报价驱动市场\nB. 保证金交易市场\nC. 指令驱动市场\nD. 经纪人市场",
            "answer": "A",
            "explain": "本题考查报价驱动市场的概述。报价驱动中，最为重要的角色就是做市商，因此报价驱动市场也被称为做市商制度。"
        }, {
            "title": "某债券型基金的久期为2.45年，当市场利率上升2%时，该债券型基金的资产净值将（　　）。",
            "question": "A. 下降4.9%\nB. 上升4.9%\nC. 下降5.3%\nD. 上升5.3%",
            "answer": "A",
            "explain": "本题考查市场利率对债券型基金资产净值的影响。债券基金的利率风险通常可采用久期进行衡量，久期越长，基金净值的波动幅度就越大，所承担的利率风险也就越高。一般而言，利率变动对债券型基金净值的影响在数值上为久期乘以利率变化所得的数值，在方向上则与市场利率变动的方向相反。"
        },
        {
            "title": "关于基金运作过程中的费用，以下不能在基金资产中列支的是（　　）。",
            "question": "A. 基金合同生效后的信息披露费用\nB. 销售服务费\nC. 基金转换费\nD. 基金的证券交易费用",
            "answer": "C",
            "explain": "本题考查基金管理过程中发生的由基金承担的费用。基金管理过程中发生的由基金承担的费用有：基金管理人的管理费、基金托管人的托管费、销售服务费、基金合同生效后的信息披露费用。"
        },
        {
            "title": "关于衍生金融工具，以下表述错误的是（　　）。",
            "question": "A. 信用违约互换合约使买方可以对卖方行使某种权利\nB. 期权合约和利率互换合约被称为单边合约\nC. 期权合约和信用违约互换合约只有一方在未来有义务\nD. 远期合约和期货合约有时被称作远期承诺",
            "answer": "B",
            "explain": "本题考查远期合约、期货合约、期权合约和互换合约的区别。期权合约和信用违约互换合约只有一方在未来有义务，被称作单边合约。远期合约和期货合约包括买卖双方在未来应尽的义务，又被称作远期承诺或者双边合约，其买卖双方损益对称。"
        },
        {
            "title": "下列投资标的不属于货币基金投资范围的是（　　）。",
            "question": "A. 剩余期限397天以内的资产支持证券\nB. 现金\nC. 剩余期限1年以内的可转换债券\nD. 期限在1年以内的同业存单",
            "answer": "C",
            "explain": "本题考查常用的货币市场工具。货币基金是指将基金资产仅投资于货币市场工具的基金，我国常用的货币市场工具包括：现金、期限在1年以内的银行存款、债券回购、中央银行票据、同业存单、剩余期限在397天以内的债券、非金融企业债务融资工具、资产支持债券。"
        },
        {
            "title": "关于权益类证券风险溢价的表述，正确的选项是（　　）。",
            "question": "A. 风险资产的风险溢价上升时，无风险资产收益率随之上升\nB. 只有非系统性风险才要求相应的风险溢价\nC. 风险资产的期望收益率与其风险溢价的正相关\nD. 当无风险资产收益率上升时，风险资产的风险溢价随之上升",
            "answer": "C",
            "explain": "本题考查权益类证券投资的收益。风险较高的权益类证券、风险较高的公司对应着一个较高的风险溢价，其期望收益率一般也较高，即期望收益率与风险溢价的正相关。"
        },
        {
            "title": "关于利润表，以下表述错误的是（　　）。",
            "question": "A. 利润表包含所得税科目\nB. 利润表的基本结构不包含盈余公积\nC. 利润表主要展示公司的损益账目，反映企业某个会计时点的业务经营状况\nD. 通过利润表可以了解企业的收支结构",
            "answer": "C",
            "explain": "本题考查利润表。利润表也称损益表是一个动态报告，展示企业的损益账目，反映一定时期内某会计时点的总体经营成果，揭示企业财务状况发生变动的直接原因，及企业获取利润的能力和经营趋势。"
        }, {
            "title": "某大学基金会的投资目标是资产的长期保值增值。该基金会当前有20%的资产配置于国内股票，80%的资产配置于国内债券，为了分散风险，提高收益，该基金会考虑了如下措施：I、将部分资产配置于国外股票 II、将部分资产配置于房地产投资 III、将部分资产配置于股权投资 IV、将所有资产配置于国内股票 V、将所有资产配置于国内债券 以上措施可以起到分散风险提高收益的目的是（　　）。",
            "question": "A. I、II、III、IV\nB. I、II、III\nC. IV、V\nD. I、III、V",
            "answer": "B",
            "explain": "本题考查资产配置。以上措施中，将部分资产配置于国外股票、房地产投资、股权投资可以起到分散风险提高收益的目的。"
        },
        {
            "title": "远期合约与期货合约相比，最主要的优点是（　　）。",
            "question": "A. 远期合约的流动性比较好\nB. 远期合约相比而言比较灵活\nC. 远期合约的违约风险比较低\nD. 远期合约具有固定的交易场所",
            "answer": "B",
            "explain": "本题考查远期合约的优点。远期合约相对于期货合约来说更加灵活，这是它最主要的优点。"
        },
        {
            "title": "在港股通机制下，下列哪类机构可接受内地投资者委托向香港联合交易所申报买卖（　　）。",
            "question": "A. 内地证券公司\nB. 上海证券交易所\nC. 深圳证券交易所\nD. 香港证券公司",
            "answer": "A",
            "explain": "本题考查基金互认、沪港通、深港通、债券通。港股通就是投资者委托内地证券服务公司，经由上海证券交易所设立的证券交易服务公司，向香港联合交易所进行申报(买卖盘传递)，买卖规定范围内的香港联合交易所上市的股票。"
        },
        {
            "title": "某日，某基金持有三种股票的数量分别为10万股、50万股和100万股，收盘价分别为30元、20元和10元，银行存款1000万元，计提的管理费和托管费合计500万元，税费500万元，基金总份额为2000万份，假设该基金再无其他资产负债项目，则当日该基金份额净值为（　　）元。",
            "question": "A. 0.5\nB. 1.15\nC. 1.65\nD. 0.65",
            "answer": "B",
            "explain": "本题考查基金份额净值的计算。基金资产净值除以基金当前的总份额，即：基金份额净值=基金资产净值/基金总份额，基金资产净值=基金资产-基金负债。"
        },
        {
            "title": "关于债券当期收益率，以下表述错误的是（　　）。",
            "question": "A. 当期收益率是债券的年利息收入与当前的债券市场价格的比率\nB. 当期收益率未考虑折价购买债券并持有到期的情况下，投资者可能遭受的资本损失\nC. 当期收益率未考虑折价购买债券并持有到期的情况下，投资者实现的资本利得\nD. 当期收益率考虑了货币的时间价值",
            "answer": "D",
            "explain": "本题考查当期收益率。当期收益率又称当前收益率，是债券的年利息收入与当前的债券市场价格的比率。"
        },
        {
            "title": "关于优先股的权利以下描述正确的是（　　）。",
            "questions": "I. 具有剩余收益权<br>II. 具有优先的表决权<br>III. 优先于债权的清偿权<br>IV. 具有股权和债权的双重特征",
            "question": "A. III、IV\nB. II、III\nC. I、II\nD. I、IV",
            "answer": "D",
            "explain": "本题考查优先股的权利。优先股具有公司剩余收益权，优先于债权的清偿权，具有股权和债权的双重特征。"
        }, {
            "title": "一般而言，以下哪只基金的跟踪误差通常比较低（　　）。",
            "question": "A. XX灵活配置基金\nB. XX上证50指数基金\nC. XX中证医药主题指数增强基金\nD. XX核心成长基金",
            "answer": "B",
            "explain": "本题考查跟踪误差。跟踪误差是度量一个股票组合相对于某基准组合偏离程度的重要指标。指数基金的跟踪误差通常较低；主动管理基金受到投资目标和风格不同的影响，跟踪误差较大；指数增强型基金有一部分资产进行主动投资，因此与一般股票型指数基金相比，该类型基金的跟踪误差更大，对基金经理管理能力的要求更高。"
        },
        {
            "title": "关于浮动利率债券，下列表述错误的是（　　）。",
            "question": "A. 浮动利率债券可以设置浮动利率的上限和下限\nB. 浮动利率债券的利差反映已发行债券在其偿还期内发行人信用的改变\nC. 浮动利率债券在每个利息支付日利息由上一日支付日的基准利率和利差共同决定\nD. 浮动利率债券的利差在发行时可以反映不同债券发行人的信用",
            "answer": "B",
            "explain": "本题考查浮动利率债券的特点。A选项表述正确，有些浮动利率债券的条款中利率存在浮动上限，即浮动利率的顶。B选项表述错误，利差在债券的偿还期内是固定的百分点，即不反映已发行债券在其偿还期内发行人信用的改变。C选项表述正确，浮动利率债券的利息在每个支付期初都会根据基准利率的变化而重新设置。"
        },
        {
            "title": "债券基金的久期与基金组合中各债券久期的关系是（　　）。",
            "question": "A. 债券基金的久期等于基金中久期最小的债券的久期\nB. 债券基金的久期等于各个债券久期的算术平均\nC. 债券基金的久期等于基金中久期最大的债券的久期\nD. 债券基金的久期等于各个债券的投资比例与对应债券久期的加权平均",
            "answer": "D",
            "explain": "本题考查债券基金的久期。债券基金的久期是组合中所有债券的久期的加权平均值。"
        },
        {
            "title": "以下不属于可转换债券的基本要素的是（　　）。",
            "question": "A. 回售条款\nB. 票面利率\nC. 股票股利\nD. 标的股票",
            "answer": "C",
            "explain": "本题考查可转换债券的基本要素。可转换债券的基本要素包含：标的股票、票面利率、转换期限、转换价格、转换比率、赎回条款、回售条款等。股票股利不属于可转换债券的基本要素。"
        },
        {
            "title": "以下选项中，关于资产负债表、利润表和现金流量表的描述正确的是（　　）。",
            "question": "A. 现金流量表是以权责发生制基础编制的\nB. 利润表是反映企业某个日期时点的盈利情况\nC. 资产负债表和现金流量表均能反映企业的收支情况\nD. 资产=负债+所有者权益",
            "answer": "D",
            "explain": "本题考查财务报表。A选项描述错误，现金流量表是以收付实现制为基础编制的。B选项描述错误，利润表亦称损益表，利润表是一个动态报告，展示企业的损益项目，反映一定时期的总体经营成果，揭示企业财务状况发生变动的直接原因。C选项描述错误，资产负债表反映了企业在特定时点的财务状况，是企业经营管理活动结果的集中体现。只有利润表可以反映企业的收支情况。D选项描述正确，资产=负债+所有者权益。"
        },
        {
            "title": "在某基金公司的晨会上，投资经理A提到“可以通过投资股票、债券、期货等来分散基金的非系统风险，且在一定程度上降低系统性风险”；投资经理B补充道“系统性风险主要受宏观因素影响，应该加强对经济，政治因素的关注”。关于两人的说法，下列表述正确的是（　　）。",
            "question": "A. A经理的说法正确，B经理的说法错误\nB. A经理的说法错误，B经理的说法正确\nC. 两者均正确\nD. 两者均不正确",
            "answer": "B",
            "explain": "本题考查风险分散化。系统性风险是指在一定程度上无法通过一定范围内的分散化投资来降低的风险。系统性风险主要受宏观因素影响，应该加强对经济，政治因素的关注。非系统性风险是可以通过构造资产组合分散掉的风险。所以A经理说法错误，B经理说法正确。"
        }, {
            "title": "关于佣金，以下说法错误的是（　　）。",
            "question": "A. A股，证券投资基金每笔交易佣金不足5元的，按5元收取\nB. 目前我国股票和基金的交易佣金实行最高上限和向下浮动制度\nC. 佣金的收费标准因交易品种，交易场所的不同有所差异\nD. 证券公司向客户收取的佣金不得高于证券交易金额的3%，但不设最低下限",
            "answer": "D",
            "explain": "本题考查佣金的收费标准。A选项说法正确，A股、证券投资基金每笔交易佣金不足5元的，按5元收取。B选项说法正确，从2002年5月1日开始，A股、B股、证券投资基金的交易佣金实行最高上限和向下浮动制度。C选项说法正确，佣金的收费标准因交易品种、交易场所的不同而有所差异。D选项说法错误，证券经纪商户客户收取的佣金(包括代收的证券交易监管费和证券交易所手续费等)不得高于证券交易金额的3%，也不得低于代收的证券交易监管费和证券交易所手续费(并非不设最低下限)。"
        },
        {
            "title": "关于远期利率，以下说法正确的是（　　）。",
            "question": "A. 远期利率是较长期限债券的收益率\nB. 远期利率高于即期利率\nC. 远期利率等效于未来特定日期购买零息债券的到期收益率\nD. 远期利率是从当前到未来某一时点的债券收益率",
            "answer": "C",
            "explain": "本题考查远期利率。A、D选项说法错误，C选项说法正确，远期利率指的是资金的远期价格，它是指隐含在给定的即期利率中从未来的某一时点到另一时点的利率水平。具体表示为未来两个日期间借入货币的利率，也可以表示为投资者在未来特定日期购买零息债券的到期收益率。B选项说法错误，远期利率与即期利率的计息日起点不同，即期利率的起点在当前时刻，而远期利率的起点在未来某一时刻。远期利率不一定高于即期利率。"
        },
        {
            "title": "关于基金管理公司下属投资部门的职责，以下表述错误的是（　　）。",
            "question": "A. 投资决策委员会负责审订公司投资管理制度和业务流程，并确定不同管理级别的操作权限\nB. 投资决策委员会是基金管理公司管理基金投资的最高决策机构\nC. 投资部负责根据交易部制定的投资策略和计划制定投资组合的具体方案\nD. 研究部通过对宏观经济形势、行业状况、上市公司等进行详细分析和研究，提出行业资产配置建议",
            "answer": "C",
            "explain": "本题考查投资管理部门的设置。不同基金公司的投资管理部门设置有所差别，但基本包括：投资部负责根据投资决策委员会制定的投资策略和计划制定投资组合的具体方案，研究部通过对宏观经济形势、行业状况、上市公司等进行详细分析和研究，提出行业资产配置建议。"
        },
        {
            "title": "关于杜邦分析法，以下表述错误的是（　　）。",
            "question": "A. 杜邦分析法利用主要的财务比率之间的关系来评价企业的财务状况\nB. 杜邦分析法是一种评价企业盈利能力和股东权益回报水平的方法\nC. 杜邦分析法有助于企业管理层和投资者清晰地看到净资产收益率的决定因素\nD. 杜邦分析法的基本思想是将企业总资产收益率逐级分解为多项财务比率乘积",
            "answer": "D",
            "explain": "本题考查杜邦分析法。杜邦分析法利用主要的财务比率之间的关系来综合评价企业的财务状况，其基本思想是将企业净资产收益率(并非总资产收益率)逐级分解为多项财务比率乘积，从而有助于深入分析比较企业经营业绩。D选项说法错误。"
        },
        {
            "title": "关于市净率模型，以下表述错误的是（　　）。",
            "question": "A. 适用于经营暂时陷入困难的公司估值\nB. 适用于银行，房地产公司的估值\nC. 适用于没有明显固定成本的服务性公司估值\nD. 适用于资产包含大量现金的公司估值",
            "answer": "C",
            "explain": "本题考查市净率模型。市净率=每股市价/每股净资产(账面价值)，市净率模型适用于以下情况：(1)市净率适用于经营暂时陷入困难的以及有破产风险的公司；(2)对于资产包含大量现金的公司，市净率是更为理想的估值指标；(3)市净率模型适用于公司股本的市场价值完全取决于有形账面价值的行业，如银行、房地产公司。对于没有明显固定成本的服务型公司，其账面价值意义不大。"
        },
        {
            "title": "形成资本市场预期，建立战略资产配置，是投资组合管理中哪一阶段的主要内容（　　）。",
            "question": "A. 规划阶段\nB. 监控阶段\nC. 执行阶段\nD. 反馈阶段",
            "answer": "A",
            "explain": "本题考查组合管理的基本步骤。形成资本市场预期，建立战略资产配置，是投资组合管理中规划阶段的主要内容。"
        }, {
            "title": "关于有效市场，以下说法正确的是（　　）。",
            "question": "A. 长期来看，采取主动投资策略的偏股型基金大概率能跑赢市场\nB. 长期来看，投资某行业的偏股型基金大概率能跑赢追踪同一行业的指数增强型基金\nC. 长期来看，跟踪同一指数的指数增强型基金大概率能战胜ETF\nD. 长期来看，采取被动投资策略的指数基金才是最佳选择",
            "answer": "D",
            "explain": "本题考查有效市场。在市场定价有效的前提下，想要提高收益，最佳的选择是被动投资策略，任何主动投资策略都将导致不必要的交易成本。"
        },
        {
            "title": "关于基金利润分配对基金份额净值的影响，以下说法中正确的是（　　）。",
            "question": "A. 无影响\nB. 会导致基金份额净值的下降\nC. 会导致基金份额净值的上升\nD. 影响不确定",
            "answer": "B",
            "explain": "本题考查基金利润分配对基金份额净值的影响。基金进行利润分配会导致基金资产净值下降，基金总份额不发生变化，所以基金份额净值会下降。"
        },
        {
            "title": "小张和小王投资一只场外货币基金，小张在上周五申购，这周四赎回，小王在上周四申购，这周五赎回，假设期间除周末外，不涉及其他法定节假日，则两人享受该货币基金分红的天数相差（　　）天。",
            "question": "A. 6\nB. 4\nC. 2\nD. 5",
            "answer": "A",
            "explain": "本题考查货币基金的利润分配。货币市场基金每周五进行分配时，将同时分配周六和周日的利润；周一至周四进行分配时，则仅对当日利润进行分配，节假日的利润计算基本与在周五申购或赎回的情况相同。"
        },
        {
            "title": "投资政策说明书的制定，主要依据投资者的（　　）。",
            "questions": "I. 投资需求<br>II. 财务状况<br>III. 投资限制<br>IV. 投资偏好",
            "question": "A. I、II、III\nB. I、III、IV\nC. I、II、IV\nD. I、II、III、IV",
            "answer": "D",
            "explain": "本题考查制定投资政策说明书的依据。"
        },
        {
            "title": "某无息债券的到期时间为180天，面额为100元，若市场贴现率为3.00%，则该债券的内在价值为（　　）元。",
            "question": "A. 98.50\nB. 99.04\nC. 97.00\nD. 94.60",
            "answer": "A",
            "explain": "本题考查零息债券估值法。期限小于1年的无息债券的计算公式为V=M(1-(t/360)r)，式中:V表示零息债券的内在价值;M表示面值;r表示年化市场利率;t表示债券到期时间。"
        },
        {
            "title": "下列科目中，流动资产不包括（　　）。",
            "question": "A. 存货\nB. 货币资金\nC. 应收账款\nD. 无形资产",
            "answer": "D",
            "explain": "本题考查流动资产的组成部分。流动资产由货币资金、应收账款、应收票据、存货以及其他流动资产构成。无形资产属于非流动资产不属于流动资产。"
        }, {
            "title": "假设某基金在2014年12月3日的单位净值为1.3425元，2015年6月1日的单位净值为1.7464元，期间该基金曾与2015年2月28日每份额派发红利0.358元。该基金2015年2月27日(除息日前一天)的单位净值为1.6473元，则该基金在这段时间的时间收益率为（　　）。",
            "question": "A. 35.47%\nB. 40.87%\nC. 55.64%\nD. 66.21%",
            "answer": "D",
            "explain": "本题考查时间加权收益率的计算。根据时间发生顺序，这段时间基金单位净值的变动为：2014年12月3日：1.3425；2015年2月27日：1.6473；2015年2月28日：1.6473-0.358=1.2893；2015年6月1日：1.7464。"
        },
        {
            "title": "货币市场工具在金融市场中发挥着重要的功能，是因为（　　）。",
            "questions": "I. 货币市场工具是金融机构管理流动性的重要手段<br>II. 货币市场工具具有良好的流动性，即使在极端情况下也不会发现风险<br>III. 企业可以通过货币市场工具获得短期融资资金<br>IV. 货币市场工具交易形成的利率为其余证券利率的定价提供了重要参考",
            "question": "A. II、IV\nB. I、III、IV\nC. I、II、III、IV\nD. I、II、III",
            "answer": "B",
            "explain": "本题考查货币市场工具的功能。货币市场工具具有良好的流动性和对经济环境的敏感性在金融市场中发挥着十分重要的功能：(1)为商业银行管理流动性以及企业融通短期资金提供了有效的手段；(2)货币市场工具交易形成的利率为其余证券利率的定价提供了重要参考。"
        },
        {
            "title": "关于港沪通和深港通所起到的作用，以下描述错误的是（　　）。",
            "question": "A. 稳定香港股市\nB. 刺激人民币资产需求，加大人民币交投量\nC. 构建良好的人民币回流机制\nD. 推动人民币跨境资本流动",
            "answer": "A",
            "explain": "本题考查沪港通与深港通。其重要意义表现为以下四个方面：(1)刺激人民币资产需求，加大人民币交投量。(2)推动人民币跨境资本流动。"
        },
        {
            "title": "关于期货交易和期权交易，以下表述正确的是（　　）。",
            "question": "A. 跟期货交易不同，期权买卖双方的盈利和亏损的机会相等\nB. 跟期货交易不同，期权交易仅用于股票\nC. 和期货交易相比，期权交易近几年才出现\nD. 跟期货交易不同，期权的买方获得一种权利而没有义务",
            "answer": "D",
            "explain": "本题考查期权交易与期货交易的区别。A选项表述错误，期权合约和信用违约互换合约只有一方在未来有义务，被称作单边合约，期权买卖双方的盈利和亏损的机会不等。B选项表述错误，跟期货交易不同，期权交易的标的资产可以是实物商品、金融资产、利率、汇率或各种综合价格指数等。"
        },
        {
            "title": "某基金为股票指数增强型基金，投资策略如下：(1)将不低于80%的资产投资于标的指数成份股和备选成分股；(2)将不低于5%的资产投资于现金或者到期日在一年以内的政府债券；(3)对剩余的资产进行主动投资。据此，以下判断错误的是（　　）。",
            "question": "A. 与一般股票型指数基金相比，该类型基金的跟踪误差更大\nB. 该类型基金的风险和预期收益率低于混合型基金\nC. 该类型基金的投资标的是获得超越标的指数的收益率\nD. 与一般股票型指数基金相比，该类型基金对基金经理管理能力的要求更高",
            "answer": "B",
            "explain": "本题考查股票基金的风险管理。A、D选项判断正确，跟踪误差是相对于业绩比较基准的相对风险指标。指数基金的跟踪误差通常较低；主动管理基金受到投资目标和风格不同的影响，跟踪误差较大。"
        },
        {
            "title": "关于大宗商品，表述不正确的是（　　）。",
            "question": "A. 具有商品属性\nB. 可进入流通领域\nC. 可在零售环节进行销售\nD. 具有实体",
            "answer": "C",
            "explain": "本题考查大宗商品的概念。大宗商品是指具有实体(D选项表述正确)，可进入流通领域(B选项表述正确)，但并非在零售环节进行销售(C选项表述错误)，具有商品属性(A选项表述正确)，用于工农业生产与消费使用的大批量买卖的物资商品。"
        }, {
            "title": "关于QDII，以下表述正确的是（　　）。",
            "question": "A. QDII是在境内募集资金进行境外证券投资的合格境内机构投资者\nB. QDII是在境内募集资金进行境外证券投资的境外机构投资者\nC. QDII是在境外募集资金进行境内证券投资的合格境内机构投资者\nD. QDII是在境外募集资金进行境内证券投资的合格境外投资者",
            "answer": "A",
            "explain": "本题考查QDII的概念。QDII是在境内募集资金进行境外证券投资的合格境内机构投资者。"
        },
        {
            "title": "关于混合基金的风险管理，以下表述错误的是（　　）。",
            "question": "A. 久期、持债集中度等指标属于债券基金的指标，混合基金无需监控\nB. 混合基金可能需要对行业集中度、持股集中度指标进行监控\nC. 一般而言，混合基金的风险和预期收益低于股票基金，高于债券基金\nD. 股票的仓位会影响混合基金的风险控制手段",
            "answer": "A",
            "explain": "本题考查混合基金的风险管理。混合基金债券仓位较高时，可参照债券型基金，侧重对基金组合久期、持债集中度等风险指标进行监控。"
        },
        {
            "title": "目前我国定期发布各类债券收益率曲线的机构包括（　　）。",
            "questions": "I. 上海清算所<br>II. 中证指数有限公司<br>III. 上海有色金属交易所<br>IV. 中央国债登记结算有限公司",
            "question": "A. I、II、IV\nB. I、II、III、IV\nC. II、III、IV\nD. I、II、III",
            "answer": "A",
            "explain": "本题考查债券收益率曲线。中央国债登记结算有限公司、中证指数有限公司、上海清算所等机构会定期发布我国各类债券的收益率曲线。"
        },
        {
            "title": "以下不符合基金暂停估值条件的是（　　）。",
            "question": "A. 基金投资所涉及的证券交易所遇到法定节假日而暂停营业\nB. 发生紧急事故，导致基金管理人不能出售或评估基金资产\nC. 基金中某个投资品种的估值出现了重大失误\nD. 不可抗力致使基金管理人无法评估基金资产",
            "answer": "C",
            "explain": "本题考查基金暂停估值的情形。占基金相当比例的投资品种的估值出现重大转变而基金管理人为保障投资人的利益已决定延迟估值，才属于基金暂停估值的情形。"
        },
        {
            "title": "下列证券中属于银行间债券市场交易的品种是（　　）。",
            "questions": "I. 中小企业集合票据\nII. 同业存单\nIII. 债券基金\nIV. 国际机构债券",
            "question": "A. I、II、III\nB. I、II、IV\nC. II、III、IV\nD. I、III、IV",
            "answer": "B",
            "explain": "本题考查银行间债券市场的交易品种。"
        },
        {
            "title": "某日投资者小李在A股市场买入X股票1000股，每股价格为40元，卖出X股票1000股，每股价格为50元，过户费率为0.02%，小李应缴纳金额为（　　）元。",
            "question": "A. 2\nB. 18\nC. 10\nD. 8",
            "answer": "B",
            "explain": "本题考查场内证券交易与结算涉及的佣金的计算。"
        }, {
            "title": "证券账户的设立和管理为以下哪家机构的主要职能（　　）。",
            "question": "A. 中国结算公司\nB. 证券公司\nC. 商业银行\nD. 证券交易所",
            "answer": "A",
            "explain": "本题考查证券登记结算机构。证券登记结算公司的职能包括对证券账户、结算账户的设立和管理。"
        },
        {
            "title": "中国证监会发布的《货币市场基金监督管理办法》中规定：当货币市场基金持有的现金、国债、中央银行票据、政策金融债券以及五个交易其他金融工具，占基金资产净值的比例合计低于5%且偏离度为负时，基金管理人应当对当日单个基金份额持有人申请赎回基金份额超过1%以上的赎回申请征收1%的强制赎回费用，并将上述赎回费用全额计入基金资产，之所以有此规定，是为了应对（　　）。",
            "question": "A. 购买力风险\nB. 流动性风险\nC. 利率风险\nD. 信用风险",
            "answer": "B",
            "explain": "本题考查货币市场基金的风险管理。购买力风险指的是作为基金利润主要分配形式的现金，可能由于通货膨胀等因素的影响而导致购买力下降，降低基金收益。"
        },
        {
            "title": "其他条件不变，债券的到期日越长，债券价格受市场利率的影响就（　　）。",
            "question": "A. 不能确定\nB. 无影响\nC. 越小\nD. 越大",
            "answer": "D",
            "explain": "本题考查债券到期日对利率风险的影响。"
        },
        {
            "title": "关于各类资本的比较，以下描述正确的是（　　）。",
            "question": "A. 公司的资产在不同证券持有者中的清偿顺序中，优先股股东优先于债券持有人，所以称为优先股\nB. 优先股股东既有固定的股息，到期还能获得本金\nC. 普通股东可以选出董事，组成董事会以代表他们监督公司的日常运行\nD. 有限责任公司中，法定代表人有自己的资产，在公司发生损失时，需要承担公司全部损失",
            "answer": "C",
            "explain": "本题考查各类资本的比较。"
        },
        {
            "title": "关于证券投资组合贝塔系数，以下表述错误的是（　　）。",
            "question": "A. 贝塔系数小于1且大于0时，该投资组合的价格变动幅度比市场小\nB. 通过对贝塔系数的计算，投资者可以得出单个证券或证券组合未来将面临的市场风险状况\nC. 贝塔系数反映投资对象对市场变化的敏感度\nD. 贝塔系数和相关系数一样，只能介于0-1之间",
            "answer": "D",
            "explain": "本题考查贝塔系数。贝塔系数是评估证券或投资组合系统性风险的指标，反映的是投资对象对市场变化的敏感度。"
        },
        {
            "title": "关于资本资产定价模型理论的前提假设，以下表述错误的是（　　）。",
            "question": "A. 所有的投资者都是风险厌恶者\nB. 投资者是价格的接受者，他们的买卖行为不会改变证券价格\nC. 只有信用优良的投资者才可以以无风险利率无限借入\nD. 所有的投资都可以无限分割，投资数量随意",
            "answer": "C",
            "explain": "本题考查资本资产定价模型的前提假设。"
        }, {
            "title": "关于证券市场线和资本市场线的比较区别，以下表述错误的是（　　）。",
            "question": "A. 资本市场线决定最适合的资产配置点\nB. 证券市场线用系统风险贝塔值衡量风险\nC. 资本市场线可以运用于有效投资组合\nD. 资本市场线的斜率是市场组合的风险溢价",
            "answer": "D",
            "explain": "本题考查证券市场线与资本市场线的区别。资本市场线的斜率是市场组合的风险溢价。"
        },
        {
            "title": "证券的回转交易是指投资者买入的证券，在（　　）全部或部分卖出。",
            "question": "A. 证券过户后\nB. 确认成交后，交收完成前\nC. 确认成交前\nD. 资金交收完成后",
            "answer": "B",
            "explain": "本题考查回转交易。"
        },
        {
            "title": "除普通股外，上市公司还发行了其他证券，以下证券风险收益特征最接近债券融资的是（　　）。",
            "question": "A. 累积优先股\nB. 非累积优先股\nC. 存托凭证\nD. 认购权证",
            "answer": "A",
            "explain": "本题考查优先股。"
        },
        {
            "title": "关于半强有效市场，说法错误的是（　　）。",
            "question": "A. 市场半强有效时价格对信息吸收过程中价格会围绕新的均衡价格上下波动\nB. 市场半强有效时对公开信息的反映会导致价格剧烈波动\nC. 如果吸收过程中价格显著高于或低于新的均衡价格表明证券市场尚未达到半强有效状态\nD. 市场半强有效代表价格对公开信息的反应是瞬间完成的",
            "answer": "D",
            "explain": "本题考查半强有效市场。市场半强有效不代表价格对信息的反应是瞬间完成的，也需要一个过程，只是这个过程比较短暂，并且伴随着交易。"
        }
    ]
}


// WEBPACK FOOTER //
// ./src/utils/fund/2024/5/jjjc-6.js